module.exports = __webpack_public_path__ + "static/media/BB.ce444bdf.png";